<template>
  <Modal v-model="isShow" width="1200" class-name="model-new" :mask-closable="false" :loading="loading" @on-ok="save">
    <div class="modalnobefore">
      <div class="flex-box">
        <Form ref="form" :rules="formRules" :model="formData" label-position="left" :label-width="90">
          <Row>
            <Col span="6" style="margin-right: 20px">
              <FormItem label="区域名称" prop="areaName">
                <Input v-model="formData.areaName" class="s-select" />
              </FormItem>
            </Col>

            <Col span="6">
              <FormItem label="区域编号" prop="areaCode">
                <Input v-model="formData.areaCode" class="s-select" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6" style="margin-right: 20px">
              <FormItem label="所属城市" prop="cityCode">
                <Select v-model="formData.cityCode" class="s-select">
                  <Option value="">请选择</Option>
                  <Option v-for="(i, index) in cityList" :value="i.value" :key="'keyA' + index">{{ i.text }}</Option>
                </Select>
              </FormItem>
            </Col>

            <Col span="6">
              <FormItem label="区域类型" prop="areaType">
                <Select v-model="formData.areaType" class="s-select">
                  <Option value="">请选择</Option>
                  <Option v-for="(i, index) in areaTypeList" :value="i.value" :key="'keyA' + index">{{ i.text }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="区域详细地址" prop="address" :label-width="100">
                <input id="suggestIdbase" v-model="formData.address" class="input-long ivu-input" />
                <!-- <Input v-model="formData.address" class="s-select"/> -->
              </FormItem>
            </Col>
          </Row>
          <!--<Button type="ghost" @click="rept" class="btn-width" :style="{ width: '90px' }">重置</Button>-->
          <!--<Button type="primary" @click="ok" class="btn-width" :style="{ width: '90px' }">查询</Button>-->
        </Form>
      </div>
      <div class="content-box">
        <div id="containerxs" class="content-l"></div>
        <div id="grouplist" style="padding: 5px; border: 1px solid #39f; color: #39f; background: #fff">
          <Radio-group v-model="type" @on-change="draw">
            <!--          <Radio label="marker">点</Radio>-->
            <!--          <Radio label="polyline">折线</Radio>-->
            <Radio label="polygon">多边形</Radio>
          </Radio-group>
          <!-- <div> -->
          <Button type="primary" size="small" shape="circle" @click="clear">清除</Button>
          <Button type="primary" size="small" shape="circle" @click="close">关闭</Button>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { selectCondition } from 'api/project';
import { getAreaInfoByFid } from 'api/area';
import { saveAreaInfo, updateAreaInfo } from 'api/area';

export default {
  watch: {
    n(val) {
      (this.loading = true), (this.isShow = true);
      this.$refs['form'].resetFields();
      this.init();
      if (this.pid && this.pid != '') this.getDetail();
    },
  },
  props: {
    pid: {
      default: null,
    },
    n: {
      default: 0,
    },
  },
  data() {
    return {
      loading: true,
      isShow: false,
      departmentList: [
        {
          value: 'beijing',
          name: '北京市',
        },
      ],
      departmentListTwo: [],
      nameList: [],
      cityList: [],
      dataList: [],
      areaTypeList: [],
      path: [],
      map: null,
      mouseTool: null,
      overlays: [],
      type: 'polygon',
      formData: {
        areaName: '',
        areaCode: '',
        cityCode: '',
        areaType: '',
        address: '',
      },
      autoCompleteComponent: null,
      formRules: {
        areaName: [{ required: true, message: '*', trigger: 'blur', type: 'string' }],
        areaCode: [{ required: true, message: '*', trigger: 'blur', type: 'string' }],
        cityCode: [{ required: true, message: '*', trigger: 'change', type: 'string' }],
        areaType: [{ required: true, message: '*', trigger: 'change', type: 'number' }],
        address: [{ required: true, message: '*', trigger: 'blur', type: 'string' }],
      },
    };
  },
  created() {
    selectCondition().then((res) => {
      this.cityList = res.data.city;
      this.areaTypeList = res.data.areaType;
    });
  },
  mounted() {},
  methods: {
    init() {
      if (this.map) this.map.clearMap();
      this.overlays = [];
      this.path=[];
      this.map = new AMap.Map('containerxs', {
        center: [116.400274, 39.905812],
        zoom: 14,
      });
      this.getDraw();
      this.autocompleteInit();
      this.draw('polygon');
      this.pushPath();
      // 缩放地图到合适的视野级别
      this.map.setFitView();
    },
    pushPath() {
      this.path.forEach((i) => {
        i.map((c) => [Number(c[0]), Number(c[1])]);
        var polygon = new AMap.Polygon({
          path: i,
          strokeColor: 'blue',
          strokeStyle: 'dashed',
          fillOpacity: 0.4,
          fillColor: '#1791fc',
          zIndex: 50,
        });
        this.map.add(polygon);
      });
    },
    autocompleteInit() {
      AMap.plugin(['AMap.AutoComplete', 'AMap.PlaceSearch'], () => {
        var autoOptions = {
          input: 'suggestIdbase', //值为界面上input空间id
          city: '全国',
        };
        this.autocomplete = new AMap.AutoComplete(autoOptions);
        var placeSearch = new AMap.PlaceSearch({
          city: '全国',
          map: this.map,
        });
        // 注册监听Autocomplete选中项;
        this.autocomplete.on('select', (e) => {
          //TODO 针对选中的poi实现自己的功能
          if (e.poi.location) this.map.setCenter(e.poi.location);
          this.formData.address = e.poi.name;
          placeSearch.search(e.poi.name);
        });
      });
    },
    getDraw() {
      this.mouseTool = new AMap.MouseTool(this.map);
      this.mouseTool.on('draw', (e) => {
        this.overlays.push(e.obj);
        // console.log(e.obj.getPath())
        // console.log(e.obj.getPosition())
        // console.log(e.obj.gePath())
      });
    },
    clear() {
      this.map.remove(this.overlays);
      this.overlays = [];
      this.path = [];
      this.map.clearMap();
      this.init();
    },
    close() {
      this.mouseTool.close(true); //关闭，并清除覆盖物
      this.type = null;
    },
    draw(type) {
      switch (type) {
        case 'marker': {
          this.mouseTool.marker({
            //同Marker的Option设置
          });
          break;
        }
        case 'polyline': {
          this.mouseTool.polyline({
            strokeColor: '#80d8ff',
            //同Polyline的Option设置
          });
          break;
        }
        case 'polygon': {
          this.mouseTool.polygon({
            fillColor: '#00b0ff',
            strokeColor: '#80d8ff',
            //同Polygon的Option设置
          });
          break;
        }
      }
    },
    getDetail() {
      getAreaInfoByFid({ fid: this.pid }).then((res) => {
        this.formData.areaName = res.data.areaName;
        this.formData.areaCode = res.data.areaCode;
        this.formData.cityCode = res.data.cityCode;
        this.formData.areaType = res.data.areaType;
        this.formData.address = res.data.address;
        if (this.path) {
          this.path = res.data.path.map((c) => [Number(c[0]), Number(c[1])]);

          //区域
          // var polygon = new AMap.Polygon({
          //   path: this.path,
          //   strokeColor: 'blue',
          //   strokeStyle: 'dashed',
          //   fillOpacity: 0.4,
          //   fillColor: '#1791fc',
          //   zIndex: 50,
          // });
          // this.map.add(polygon);
          this.path = res.data.path;
          this.path.forEach((i) => {
            i.map((c) => [Number(c[0]), Number(c[1])]);
            var polygon = new AMap.Polygon({
              path: i,
              strokeColor: 'blue',
              strokeStyle: 'dashed',
              fillOpacity: 0.4,
              fillColor: '#1791fc',
              zIndex: 50,
            });
            this.map.add(polygon);
          });
          // 缩放地图到合适的视野级别
          this.map.setFitView(this.map.getAllOverlays());
        }
      });
    },
    save() {
      let arr = [];
      this.overlays.map((i) => {
        //   arr.push([i.lon,i.lat])
        // }
        let arrs = [];
        i.getPath().map((s) => {
          arrs.push([s.lng, s.lat]);
        });
        arr.push(arrs);
      });
      this.path.map((i) => {
        arr.push(i);
      });
      this.$refs['form'].validate((bool) => {
        if (bool) {
          if (this.pid && this.pid != '') {
            const param = {
              pathList: arr,
              fid: this.pid,
              ...this.formData,
            };
            updateAreaInfo(param)
                .then((res) => {
                  this.$Message.success('更新成功');
                  this.changeLoading();
                  this.$emit('done');
                  this.isShow = false;
                })
                .catch(() => {
                  this.changeLoading();
                  return;
                });
          } else {
            const param = {
              pathList: arr,
              ...this.formData,
            };
            saveAreaInfo(param)
                .then((res) => {
                  this.$Message.success('保存成功');
                  this.changeLoading();
                  this.$emit('done');
                  this.isShow = false;
                })
                .catch(() => {
                  this.changeLoading();
                  return;
                });
          }
        } else {
          this.changeLoading();
          return;
        }
      });
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modalnobefore {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 650px;
}
.flex-box {
  //display: flex;
  //margin-bottom: 24px;
  //& > div {
  //  flex: auto;
  //  display: flex;
  //  margin-right: 20px;
  //  span {
  //    display: flex;
  //    width: auto;
  //    line-height: 30px;
  //  }
  //
  //}
}
.content-box {
  flex: 1;
  display: flex;
  position: relative;
  .content-l {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
  }
  #grouplist {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .content-r {
    flex: auto;
    .r-title {
      background: #649dd6;
      color: #fff;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      .refresh {
        color: #fff;
        cursor: pointer;
        float: right;
        margin-right: 20px;
      }
    }
    .content {
      padding: 20px;
      li {
        border-bottom: 1px solid #ccc;
        margin-bottom: 10px;
        &:last-child {
          border-bottom: none;
        }
        p {
          height: 30px;
          line-height: 30px;
          .r-name {
            font-weight: bold;
            color: green;
            cursor: pointer;
            display: inline-block;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.model-new {
  height: 600px;
}
#container {
  /deep/ .amap-info-content {
    padding: 0;
    background: #fff;
    min-width: 250px;
  }
  /deep/ .amap-info-close {
    right: 0 !important;
    top: 3px;
  }
  /deep/ .info-content {
    padding: 10px;
    p {
      line-height: 25px;
      height: 25px;
      padding: 5px;
      color: #333;
      word-break: break-all;
      width: 200px;
    }
    margin-bottom: 10px;
  }
}
</style>
